import type { RootState } from '../../reducers';

const selectRawProduct = (state: RootState): RootState['product'] | null => state?.product ?? null;

export default selectRawProduct;
